var $6a6f2c49f92bd42e$exports = {};
$6a6f2c49f92bd42e$exports = {
    "Empty": `Vuoto`
};


export {$6a6f2c49f92bd42e$exports as default};
//# sourceMappingURL=it-IT.mjs.map
